import React from "react";
import { Link } from "react-router-dom";

import { sectionSevenStats } from "../../data";
import {
  SectionEight,
  SectionEightIntro,
  SectionEightIntroInner,
  SectionEightMainTitle,
  SectionEightSideText,
  SectionEightContent,
  SectionEightStats,
  SectionEightStat,
  SectionEightStatImage,
  SectionEightStatLabel,
  SectionEightFooter,
  SectionEightFooterText,
  SectionEightCta,
} from "./styles";

const LOGIN_URL = "https://www.trataz.com.br/login";

export default function SectionEightComponent() {
  return (
    <SectionEight>
      <SectionEightIntro>
        <SectionEightIntroInner>
          <SectionEightMainTitle>
            <strong>POR QUE FUNCIONA?</strong>
            <br />
            PORQUE OS RECURSOS
            <br />
            <strong>SÃO EFICIENTES.</strong>
          </SectionEightMainTitle>

          <SectionEightSideText>
            <strong>Transforme</strong> seus Atendimentos.
            <br />A Trataz é a <strong>solução ideal</strong> para
            <br />
            profissionais que buscam
            <br />
            <strong>modernizar sua prática clínica</strong> e
            <br />
            <strong>melhorar</strong> os resultados dos tratamentos.
          </SectionEightSideText>
        </SectionEightIntroInner>
      </SectionEightIntro>

      <SectionEightContent>
        <SectionEightStats>
          {sectionSevenStats.map((item) => (
            <SectionEightStat key={item.title}>
              <SectionEightStatImage>{item.title}</SectionEightStatImage>
              <SectionEightStatLabel>{item.label}</SectionEightStatLabel>
            </SectionEightStat>
          ))}
        </SectionEightStats>

        <SectionEightFooter>
          <SectionEightFooterText>
            COMECE SEM RISCO, EVOLUA NO SEU RITMO.
          </SectionEightFooterText>

          <SectionEightCta
            as={Link}
            to={LOGIN_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            COMECE JÁ! TESTE GRATUITO.
          </SectionEightCta>
        </SectionEightFooter>
      </SectionEightContent>
    </SectionEight>
  );
}
